var React = require('react');
import SimpleSampleInput from './subcomponents/SimpleSampleInput';

class SimpleAddSample extends React.Component {

    constructor(){
        super();
        this.state = {
            samples: [],
            options: JSON.parse(document.getElementById('json_beers').value)
        };
        this.clickOnSimpleAddSample = this.clickOnSimpleAddSample.bind(this);
        this.removeSample = this.removeSample.bind(this);
        this.chooseSample = this.chooseSample.bind(this);
    }

    clickOnSimpleAddSample(){
        this.setState({
            samples: this.state.samples.concat([''])
        })
    }

    removeSample(index){
        let samples = this.state.samples;
        samples.splice(index, 1);
        this.setState({
            samples: samples
        });
    }

    chooseSample(index, selection){
        let samples = this.state.samples;
        samples[index] = selection;
        this.setState({
            samples: samples
        });
    }

    samples(){
        return this.state.samples.map((sample, index)=>{
            return (
                <SimpleSampleInput
                    key={index}
                    index={index}
                    sample={sample || this.state.options[0].id }
                    removeSample={this.removeSample}
                    chooseSample={this.chooseSample}
                    options={this.state.options}
                    missing_message={'No beers for this brewery'}
                    input_name={'beer_selection'}
                />
            );
        })
    }

    render() {
        return (
            <div className="text-center w100">
                <div className="text-left">
                    <a id="add_sample" className="add-beer" onClick={this.clickOnSimpleAddSample}>+</a>
                    {this.samples()}
                </div>
            </div>
        );
    }
}

export default SimpleAddSample